import React, { Fragment, useContext, useEffect, useState } from "react";
import "./Order.css";
import { useCart } from "../../../context/CartContext";
import Card from "../../../components/molecules/cards/card/Card";
import Hr from "../../../components/molecules/hr/Hr";
import Check from "../../../components/atoms/icons/general/check/Check";
import { useWindowSize } from "@uidotdev/usehooks";
import OrderForm from "../../../components/forms/account/orderForm/OrderForm";
import AppContext from "../../../context/AppContext";

function Order() {
  const { width } = useWindowSize();
  const { cart } = useCart();

  const { setBannerConfig } = useContext(AppContext);

  useEffect(() => {
    setBannerConfig({
      title: <>Ma commmande</>,
      subtitle: <>Vérifiez votre commande avant de valider votre achat</>,
    });
  }, []);

  return (
    <>
      <section className='container page-container'>
        <div className='recap-container'>
          <div className='recap-card-container'>
            <Card bgColor='var(--light-blue)' className='abonnement-card'>
              <h2>Récapitulatif de ma&nbsp;commande</h2>
              <Hr />
              <table className='recap-table'>
                <thead className={width <= 576 ? "d-none" : ""}>
                  <tr>
                    <th className='nom-offre-thead'>Nom de {width <= 576 ? <br /> : ""} l'offre</th>
                    <th className='inclus-offre-thead'>Inclus dans {width <= 576 ? <br /> : ""} votre offre</th>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <Hr />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((item, index) => (
                    <Fragment key={`item-${index}`}>
                      <tr>
                        <td className='selection-offre-recap'>
                          <h3>{item.price_name}</h3>
                          {item.price_name === "Maestro" || item.price_name === "Optimum" ? (
                            <p className='engagement-abonnement-recap'>
                              Abonnement avec engagement&nbsp;
                              <br />
                              de 12 mois
                            </p>
                          ) : null}
                          <ul className={`mt-sm recap-inclus-offre ${width > 576 ? "d-none" : ""}`}>
                            <li className='flex details-1-recap'>
                              <Check width='15px' className='check-min-width' />
                              Nombre illimité d'estimations avec rapport détaillé
                            </li>
                            <li className='flex details-1-recap'>
                              <Check width='15px' className='check-min-width' />
                              Accès aux ressources suivantes :
                            </li>
                            <ul className='ml-md dots-list details-2-recap'>
                              <li>Outils pratiques à télécharger</li>
                              <li>Conseils de pros</li>
                              <li>Nos guides pour agents immos</li>
                              <li>Plan de financement</li>
                              <li>Simulation de prêt</li>
                              <li>Calculateur de cotisations</li>
                            </ul>
                          </ul>
                        </td>
                        <td className='inclus-offre-recap'>
                          <ul className={width <= 576 ? "d-none" : ""}>
                            <li className='flex details-1-recap'>
                              <Check width='15px' className='check-min-width' />
                              Nombre illimité d'estimations avec rapport détaillé
                            </li>
                            <li className='flex details-1-recap'>
                              <Check width='15px' className='check-min-width' />
                              Accès aux ressources suivantes :
                            </li>
                            <ul className='ml-md dots-list details-2-recap'>
                              <li>Outils pratiques à télécharger</li>
                              <li>Conseils de pros</li>
                              <li>Nos guides pour agents immos</li>
                              <li>Plan de financement</li>
                              <li>Simulation de prêt</li>
                              <li>Calculateur de cotisations</li>
                            </ul>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan='2'>
                          <Hr />
                        </td>
                      </tr>
                    </Fragment>
                  ))}
                </tbody>
              </table>
              <div className='checkbox-commande-container'>
                <OrderForm />
              </div>
            </Card>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order;
